import {useDesignServiceQuery} from "./useDesignServiceQuery";
import {useScreenSizeDetector} from "./useScreenSizeDetector";
import {useDesignServiceId} from "../redux/stateHooks";

export const useDesignServiceState = () => {
    const {model: {id, formatted: {price}}, onChange} = useDesignServiceQuery();
    const {isSmallScreenSize} = useScreenSizeDetector();
    const designServiceId = useDesignServiceId();

    return {
        model: {
            price,
            smallScreenSize: isSmallScreenSize,
            checked: designServiceId == id,
            breakOutEarly: !id || !price,
            onChange: () => onChange()
        }
    };
}